<template>
  <el-dialog
    :custom-class="`r-modal ${
      modalSize === 'xxl-modal' ? 'r-modal-fullScreen' : ''
    } ${customClass}`"
    :title="title"
    v-model="showValue"
    :top="top"
    :width="modalWidth"
    @close="_onCancel"
    @open="$emit('open')"
    :append-to-body="mask"
    :close-on-click-modal="closeOnClick"
    destroy-on-close
  >
    <slot name="content">{{ content }}</slot>
    <template #footer>
      <div class="dialog-footer" v-show="showFooter || $slots.footer">
        <slot name="footer">
          <el-button class="btn btn-white" @click="_onCancel">{{
            cancelText
          }}</el-button>
          <el-button class="btn btn-primary" @click="_onConfirm">{{
            confirmText
          }}</el-button>
        </slot>
      </div>
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: "RModal",
  model: {
    prop: "show",
    event: "change",
  },
  emits: ["change", "open", "on-show", "close"],
  props: {
    mask: {
      type: Boolean,
      default: true,
    },
    show: {
      type: Boolean,
      default: false,
    },
    title: String,
    content: String,
    confirmText: {
      type: String,
      default: "确定",
    },
    cancelText: {
      type: String,
      default: "取消",
    },
    top: {
      type: String,
      default: "15vh",
    },
    width: {
      type: String,
      default: "",
    },
    showFooter: {
      type: Boolean,
      default: false,
    },
    modalSize: {
      type: String,
      default: "m-modal",
    },
    closeOnClick: {
      type: Boolean,
      default: true,
    },
    customClass: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      modalWidth: "800px",
    };
  },
  computed: {
    showValue: {
      get() {
        const val = this.show;
        if (val) {
          this.$emit("on-show");
        }
        return val;
      },
      set(val) {
        if (val !== this.showValue) {
          this.$emit("change", val);
        }
      },
    },
  },
  mounted() {
    if (this.width) {
      this.modalWidth = this.width
    } else if (this.modalSize) {
      switch (this.modalSize) {
        case "xs-modal":
          this.modalWidth = "400px";
          break;
        case "s-modal":
          this.modalWidth = "600px";
          break;
        case "m-modal":
          this.modalWidth = "800px";
          break;
        case "l-modal":
          this.modalWidth = "1000px";
          break;
        case "xl-modal":
          this.modalWidth = "90%";
          break;
        case "xxl-modal":
          break;
      }
    }
  },
  methods: {
    _onConfirm(val) {
      this.$emit("on-confirm", val);
    },
    _onCancel() {
      if (!this.showValue) return;
      this.$emit("close");
      this.$emit("change", false);
    },
  },
};
</script>

<style lang="less">
.el-dialog {
  border-radius: 12px;
  .el-dialog__header {
    border-bottom: 1px solid rgba(151, 151, 151, 0.4);
    .el-dialog__title {
      color: #000;
      font-weight: 500;
    }
    .el-dialog__close {
      color: #000;
    }
  }
  .el-dialog__body {
    max-height: 750px;
    min-height: 300px;
    overflow-y: auto;
    padding: 20px 60px;
  }
  .el-dialog__footer {
    padding-bottom: 40px;
  }
}
</style>